import {
  parseSearchNumberValue,
  parseSearchStringValue,
} from 'infrastructure/functions/parse-query-string';
import { useQueryFilterNew } from 'infrastructure/hooks/common/use-query-param-new';
import { endOfMonth, startOfMonth } from 'date-fns';

import type { TParseFunctions } from 'infrastructure/hooks/common/use-query-param-new';
import type { ILinkCallReadingsToolFilters } from './types';

const DEFAULT_FILTERS: ILinkCallReadingsToolFilters = {
  startTime: startOfMonth(new Date()).getTime(),
  endTime: endOfMonth(new Date()).getTime(),
  page: 1,
};

const parseFunctions: TParseFunctions<ILinkCallReadingsToolFilters> = {
  page: parseSearchNumberValue,
  startTime: parseSearchNumberValue,
  endTime: parseSearchNumberValue,
  sourcePhone: parseSearchStringValue,
  callId: parseSearchStringValue,
  agent: parseSearchStringValue,
};

export const useLinkCallReadingsToolFilters = () => {
  return useQueryFilterNew<ILinkCallReadingsToolFilters>(
    DEFAULT_FILTERS,
    parseFunctions,
    ['page', 'endTime'],
  );
};
